class ComparisonTable extends HTMLElement {
  constructor() {
    super();

    this.urlParams = new URLSearchParams(window.location.search);
    this.collectionHandle = this.urlParams.get('collection');
    this.comparisonHandles = this.getComparisonData(this.collectionHandle);
    this.searchQuery = this.urlParams.get('search');
    // const storefrontApiToken = '05df33cdb1722936a8b19284d0abfdf1';
    this.dataset.productCount = this.comparisonHandles.length;
    this.comparisonGrid = this.querySelector('.comparison__grid');

    this.metafields = [
      'leg_material',
      'orientation_chaise_side',
      'overall_width',
      'seat_height',
      'seat_depth',
      'arm_height',
      'leg_height',
      'arm_width',
      'back_height',
    ];

    window.addEventListener('resize', this.setCellHeight.bind(this));

    this.buildBackUrl();
    this.buildShareUrl();

    if (this.comparisonHandles.length > 0) {
      this.fetchProductData().then((products) => {
        this.displayComparison(products);
      });
    } else {
      this.innerHTML = '<p>Your comparison is empty.</p>';
    }
  }

  getComparisonData(collectionHandle) {
    // if (!!localStorage.getItem('comparison') && !!JSON.parse(localStorage.getItem('comparison'))[collectionHandle]) {
    //   return JSON.parse(localStorage.getItem('comparison'))[collectionHandle];
    // } else {
    return this.urlParams.get('handles').split(',');
    // }
  }

  async fetchProductData() {
    const generateProductQuery = (handle, index) => `
      product${index}: productByHandle(handle: "${handle}") {
        id
        title
        vendor
        handle
        description
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        images(first: 1) {
          edges {
            node {
              originalSrc
              altText
            }
          }
        }
        metafields(identifiers: [ 
          {namespace: "custom", key: "shop_url"}, 
          {namespace: "custom", key: "leg_material"}, 
          {namespace: "custom", key: "orientation_chaise_side"}, 
          {namespace: "custom", key: "overall_width"},
          {namespace: "custom", key: "seat_height"},
          {namespace: "custom", key: "seat_depth"},
          {namespace: "custom", key: "arm_height"},
          {namespace: "custom", key: "leg_height"},
          {namespace: "custom", key: "arm_width"},
          {namespace: "custom", key: "back_height"},
        ]) { 
          key
          value
        }
      }
    `;

    const query = `
      query {
        ${this.comparisonHandles.map((handle, index) => generateProductQuery(handle, index)).join('\n')}
      }
    `;

    try {
      const response = await fetch('/api/2023-04/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '05df33cdb1722936a8b19284d0abfdf1',
        },
        body: JSON.stringify({ query }),
      });

      const data = await response.json();

      if (data.errors) {
        console.error('GraphQL errors:', data.errors);
        return [];
      }

      const products = this.comparisonHandles.map((_, index) => data.data[`product${index}`]);
      return products;
    } catch (error) {
      console.error('Error fetching product data:', error);
      return [];
    }
  }

  titleize(string) {
    return string
      ?.replace(/_/g, ' ')
      ?.split(' ')
      ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      ?.join(' ');
  }

  handleize(string) {
    return string
      ?.toLowerCase()
      ?.replace(/_/g, '-')
      ?.replace(/[^a-z0-9-]/g, '');
  }

  setCellHeight() {
    const basicCells = this.querySelectorAll('.comparison__cell--basic');
    const maxBasicHeight = Math.max(...Array.from(basicCells).map((el) => el.offsetHeight));
    basicCells.forEach((el) => (el.style.height = `${maxBasicHeight}px`));
    for (const index in this.metafields) {
      const metafield = this.querySelectorAll(`.comparison__cell--metafield.${this.handleize(this.metafields[index])}`);
      const maxHeight = Math.max(...Array.from(metafield).map((el) => el.offsetHeight));
      metafield.forEach((el) => (el.style.height = `${maxHeight}px`));
    }
  }

  buildBackUrl() {
    const collectionLink = document.createElement('a');
    collectionLink.href =
      (this.collectionHandle == 'search' && `/search?q=${this.searchQuery}`) ||
      (this.collectionHandle == 'wishlist' && '/pages/wishlist') ||
      `/collections/${this.collectionHandle}`;
    collectionLink.classList.add('comparison__collection-link');
    collectionLink.textContent =
      this.collectionHandle == 'search' || this.collectionHandle == 'wishlist'
        ? `< Back to ${this.collectionHandle}`
        : '< Back to collection';
    this.querySelector('.comparison__utilities')?.appendChild(collectionLink);
  }

  buildShareUrl() {
    const shareUrl = document.createElement('a');
    shareUrl.classList.add('comparison__share');
    shareUrl.classList.add('gtm--compare__share');
    shareUrl.href = 'javascript:void(0);';
    shareUrl.dataset.shareUrl = window.location.href;
    shareUrl.textContent = 'Share';

    this.querySelector('.comparison__utilities')?.appendChild(shareUrl);
  }

  onShareClick(event) {
    const shareButton = event.target;
    shareButton.textContent = 'URL Copied!';
    navigator.clipboard.writeText(shareButton.dataset.shareUrl);
    setTimeout(function () {
      shareButton.textContent = 'Share';
    }, 2000);
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      if (event.target.classList.contains('comparison__share')) {
        this.onShareClick(event);
      }
    });
    this.addEventListener('click', (event) => {
      if (event.target.classList.contains('comparison__remove')) {
        this.onRemoveClick(event);
      }
    });
  }

  onRemoveClick(event) {
    const handle = event.target.dataset.productHandle;
    const updatedComparison = this.comparisonHandles.filter((productHandle) => productHandle !== handle);
    // localStorage.setItem(
    //   'comparison',
    //   JSON.stringify({ [new URLSearchParams(window.location.search).get('collection')]: updatedComparison })
    // );
    document.querySelector(`.comparison__col[data-product-handle="${handle}"]`)?.remove();
  }

  displayPrice(product) {
    const productPrice = parseFloat(product.priceRange.minVariantPrice.amount).toFixed(2);
    return productPrice.endsWith('.00') ? `$${productPrice.slice(0, -3)}` : `$${productPrice}`;
  }

  displayComparison(products) {
    for (const product of products) {
      const productCol = document.createElement('div');
      productCol.classList.add('comparison__col');
      productCol.dataset.productHandle = product.handle;

      productCol.innerHTML = `
      <div class="comparison__cell comparison__cell--basic">
        <a href="javascript:void(0);" class="comparison__remove" data-product-handle="${product.handle}">X</a>
        <a href="/products/${product.handle}" class="gtm--compare__product-page">
          <img class="comparison__image" height="120" src="${product.images.edges[0].node.originalSrc}" alt="${
        product.images.edges[0].node.altText
      }">
          <span class="comparison__vendor">${product.vendor}</span>
          <span class="comparison__name">${product.title}</span>
        </a>
      </div>
      <div>
        <a href="${
          product.metafields.find((metafield) => metafield?.key === 'shop_url')?.value || `/products/${product.handle}`
        }" class="comparison__shop gtm--compare__shop-external button button--small button--full-width" target="_blank">Shop Now</a>
      </div>
      <div class="comparison__cell comparison__cell--price">
        <span class="comparison__label">Price</span>
        ${this.displayPrice(product)}
      </div>
    `;

      for (const mfIndex in this.metafields) {
        productCol.innerHTML += `
          <div class="comparison__cell comparison__cell--metafield ${this.handleize(this.metafields[mfIndex])}">
          <span class="comparison__label">${this.titleize(this.metafields[mfIndex])}</span>
          ${product.metafields.find((metafield) => metafield?.key === this.metafields[mfIndex])?.value || '--'}</div>`;
      }
      this.comparisonGrid.appendChild(productCol);
    }
    this.setCellHeight();
  }
}

customElements.define('comparison-table', ComparisonTable);
